import { Component, Input, OnInit } from '@angular/core';
import {
  getMprdProductType,
  Option,
  OptionStatus,
  Product,
} from '@dch/products-business-logic';
import { getAlertKey, onResult } from '../../../shared/order-utils/order-utils';
import { LanguageService, TranslationService } from '@proximus/ng-common';
import {
  AlertsService,
  ModalService,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import { savePii } from 'src/app/shared/pii/pii.utils';

@Component({
  selector: 'mprd-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css'],
})
export class SettingComponent implements OnInit {
  OptionStatus = OptionStatus;
  savePii = savePii;

  @Input() setting: Option;
  @Input() product: Product;

  productType: string;

  constructor(
    private translationService: TranslationService,
    private languageService: LanguageService,
    private modalService: ModalService,
    private alertsService: AlertsService,
    private pxModalMessageService: PxModalMessageService,
  ) {}

  ngOnInit(): void {
    if (this.product) {
      this.productType = getMprdProductType(this.product);
    }
  }

  getAlertKey(): string {
    return getAlertKey(undefined, this.setting);
  }

  onResult(event) {
    onResult(
      event,
      undefined,
      undefined,
      this.setting,
      this.translationService,
      this.languageService,
      this.modalService,
      this.pxModalMessageService,
      this.alertsService,
      undefined,
      false,
      true,
    );
  }
}
